export const SET_MACHINE_STRUCTURE_DATA = "SET_MACHINE_STRUCTURE_DATA";
export const SET_KITCHEN_EVENTS = "SET_KITCHEN_EVENTS";
export const SET_ACTIVE_MODULE_TYPE = "SET_ACTIVE_MODULE_TYPE";
export const SET_ACTIVE_MODULE_TYPE_DATA = "SET_ACTIVE_MODULE_TYPE_DATA";
export const SET_ACTIVE_MODULE = "SET_ACTIVE_MODULE";
export const SET_ACTIVE_MODULE_DATA = "SET_ACTIVE_MODULE_DATA";
export const SET_ACTIVE_SYSTEM = "SET_ACTIVE_SYSTEM";
export const SET_ACTIVE_SYSTEM_DATA = "SET_ACTIVE_SYSTEM_DATA";

export const SET_RESTAURANT_DATA = "SET_RESTAURANT_DATA";
